'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { BzImage } from '@benzinga/image';
import { BenzingaProLogo } from '@benzinga/logos-ui';
import { Button } from '@benzinga/core-ui';

export const BenzingaProBannerAd: React.FC = () => {
  return (
    <Container className="w-full flex items-center justify-center">
      <a
        className="benzinga-pro-ad-background"
        href="https://pro.benzinga.com/?utm_source=razreport"
        rel="noreferrer"
        target="_blank"
      >
        <div className="benzinga-pro-ad-image-wrapper mt-[-4rem] relative">
          <BzImage
            alt=""
            height={300}
            layout="fill"
            loaderProps={{ width: 400 }}
            loading="lazy"
            objectFit="contain"
            src="/next-assets/images/raz-report/BenzingaProPlatformScreenshot.png"
          />
        </div>
        <div className="flex flex-col items-center md:items-baseline md:px-6">
          <BenzingaProLogo className="w-[9rem] mb-2 mt-1.5 md:w-[15rem]" variant="blue" />
          <p className="max-w-[14rem] w-full text-center md:text-left md:max-w-none md:my-4">
            Join <b>80K+</b> subscribers and receive exclusive tools, <br /> tips, and resources to trade like a pro
            with <b>Benzinga Pro</b>
          </p>
          <Button variant="flat-blue">GET ACCESS</Button>
        </div>
      </a>
    </Container>
  );
};

export default BenzingaProBannerAd;

const Container = styled.span`
  .benzinga-pro-ad-background {
    background-image: url('/next-assets/images/raz-report/BenzingaProAdBackgroundMobile.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 450px;
    height: 100%;
    padding: 1.5rem 1rem;
    color: #ffffff;
    margin-top: 3rem;
    border-radius: ${({ theme }) => theme.borderRadius.md};

    @media (min-width: 780px) {
      background-image: url('/next-assets/images/raz-report/BenzingaProAdBackground.png');
    }

    button {
      padding-left: 2rem;
      padding-right: 2rem;
    }

    @media (min-width: 780px) {
      max-width: unset;
      height: 260px;
      width: 100%;
      flex-direction: row-reverse;
      justify-content: space-between;
    }

    .benzinga-pro-ad-image-wrapper {
      height: 125px;
      width: 50%;
      white-space: nowrap;
      position: relative;
      cursor: pointer;

      @media (min-width: 450px) {
        height: 175px;
      }

      @media (min-width: 780px) {
        width: 430px;
        height: 300px;
      }
    }
  }
`;
